export default function Home() {
  return <h1></h1>;
}
